import Api from './api.service';

const ENDPOINT = 'users';

export default {
  requestPasswordReset: (email) =>
    Api.get(`${ENDPOINT}/password-reset-request`, { params: { email } }),
};
